import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Recaptcha from 'react-recaptcha'
import Select from 'react-select'
import moment from 'moment'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import Error from './Utils/Error'
import { capitalizeFirstLetter } from '../utils/utils'
import Notification from './Utils/Notification'
import { INFO } from '../utils/constants'
import Button from './Utils/Button'
import Spinner from './Utils/Spinner'
import Cookies from 'universal-cookie'
import { setPricing, textTranslation, shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'
import { gaEvents } from '../analytics/events'
import { isValidEmail } from '../utils/utils'
import ErrorLabel from './Utils/ErrorLabel'

const cookies = new Cookies()

const Modal = ({ handleClose, showModal, data, modalContent, children }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block'
    : 'modal-aaa aaa-display-none'

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {modalContent == 'Terms of Supply'
              ? decode(data[36])
              : modalContent == 'Terms of Use'
                ? decode(data[38])
                : decode(data[40])}
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        {children}
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </section>
    </div>
  )
}

class SignupGiftActivate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      emailError: '',
      code: '',
      error: '',
      errorText: '',
      password: '',
      password_confirmation: '',
      passwordError: '',
      loading: false,
      valid: true,
      showCode: false,
      showPassword: false,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleEmailValidation = this.handleEmailValidation.bind(this)
    this.handleGiftActivation = this.handleGiftActivation.bind(this)
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.handlePasswordValidation = this.handlePasswordValidation.bind(this)
    this.verifyCode = this.verifyCode.bind(this)
  }

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search)
    const code = query.get('code') !== null ? query.get('code') : ''
    this.setState({ code })
    if (code == '') {
      this.setState({ showCode: true })
    }
    // If the user is authenticated, we're sending him back to the Login Page
    if (this.props.auth.user === null || this.props.auth.user.id === '') {
      this.verifyCode(code)
    } else {
      this.props.history.push('/dashboard')
    }
    axios
      .get('/api/languages-all')
      .then((res) => {
        const languages = res.data.map(function (language) {
          return { label: language.name, value: language.id }
        })
        this.setState({ languages })
        const language = shouldTranslateTo()
        const getPageText = (pageValue, languageValue) => {
          axios
            .get(`/api/page-text/${pageValue}/${languageValue}`)
            .then((response) => {
              let pageText = response.data.map((textItem) => {
                return textItem.text
              })
              this.setState({
                signupData: pageText,
              })
            })
            .catch((err) => {
              console.log('Error getting page text: ', err)
            })
        }
        getPageText('signup', language)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  verifyCode(code) {
    if (code !== '') {
      axios
        .post('/api/gift/code/verify', { code: code })
        .then((response) => {
          if (response.data.success === false) {
            this.props.history.push('/loginsignup')
          }
        })
        .catch((err) => {
          this.setState({ error: err })
        })
        .finally(() => {
          this.setState({ loading: false })
        })
    }
  }

  showModal(e) {
    e.preventDefault()
    this.setState({
      showModal: true,
      modalContent: e.target.getAttribute('data-title'),
    })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  handleValidationFailure = (errorKey, errorMessage) => {
    this.setState({
      loading: false,
      valid: false,
      error: decode(errorMessage),
      [errorKey]: decode(errorMessage),
    })
  }

  validateForm = () => {
    const { code, showPassword, password, password_confirmation, signupData } =
      this.state

    if (!code) {
      this.handleValidationFailure('codeError', 'You must enter a code')
      return
    }
    if (showPassword) {
      if (password !== password_confirmation) {
        this.handleValidationFailure('passwordError', signupData[25])
        return
      }
    }
    this.setState({ valid: true, error: '' })
  }

  handleGiftActivation(e) {
    console.log('---')
    e.preventDefault()
    this.validateForm()
    if (this.state.valid) {
      this.setState({ loading: true })

      const data = {
        email: this.state.email,
        code: this.state.code,
      }

      if (this.state.showPassword) {
        data.password = this.state.password
        data.password_confirmation = this.state.password_confirmation

        axios
          .post('/api/gift/activate', data)
          .then((response) => {
            this.props.auth.handleLogin(response.data.user)
            this.props.history.push('/dashboard')
          })
          .catch((err) => {
            this.setState({ error: err })
          })
          .finally(() => {
            this.setState({ loading: false })
          })
      } else {
        axios
          .post('/api/gift/verify', data)
          .then((response) => {
            if (response.data.success === false) {
              this.setState({
                loading: false,
                valid: false,
                error: 'Invalid email or code',
              })
            } else {
              this.setState({ showPassword: true })
            }
          })
          .catch((err) => {
            this.setState({ error: err })
          })
          .finally(() => {
            this.setState({ loading: false })
          })
      }
    }
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState((prevState) => {
      prevState[name] = value
      return prevState
    })
  }

  handleEmailValidation() {
    if (!isValidEmail(this.state.email)) {
      this.setState({ emailError: 'Please enter a valid email address' })
      this.setState({ errorText: decode(this.state.signupData[43]) })
    } else {
      this.setState({ emailError: '' })
      this.setState({ errorText: '' })
    }
  }

  handlePasswordValidation() {
    const { password, password_confirmation } = this.state

    if (password && password_confirmation) {
      if (password !== password_confirmation) {
        this.setState({ passwordError: 'Passwords do not match' })
        this.setState({ errorText: decode(this.state.signupData[25]) })
        return
      }
    }
    this.setState({ passwordError: '' })
    this.setState({ errorText: '' })
  }

  render() {
    if (!this.state.signupData) {
      return null
    }

    return (
      <div>
        {cookies.get('bC') !== '' &&
        cookies.get('bC') !== null &&
        cookies.get('bC') !== undefined ? (
          <section id="dba-1" className="dba">
            <div className="container">
              <img
                src={'/images/dbanner/banner-' + cookies.get('bC') + '-1.jpg'}
                alt=""
              />
            </div>
          </section>
        ) : null}
        <section className="contact-wrapper signup">
          {this.state.loading && <Spinner />}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="contact_form">
                  <h3 className="title">{decode(this.state.signupData[0])}</h3>
                  <p className="font-size-16 text-black intro">
                    {decode(this.state.signupData[1])}{' '}
                    {decode(this.state.signupData[34])}{' '}
                    <a href="mailto:hello@thefreebirdclub.com">
                      hello@thefreebirdclub.com
                    </a>{' '}
                    {decode(this.state.signupData[29])}
                  </p>

                  <div id="activateGift">
                    <form
                      method="POST"
                      action="/gift/activate"
                      name="myForm"
                      aria-label="ActivateGift"
                      onSubmit={(e) => this.handleGiftActivation(e)}
                    >
                      <hr />
                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[17])}</label>

                        <input
                          className={`form-control person-email ${
                            this.state.emailError && 'red-border'
                          }`}
                          id="email"
                          type="email"
                          name="email"
                          required
                          value={this.state.email}
                          onChange={this.handleInputChange}
                          onBlur={this.handleEmailValidation}
                        />
                      </div>
                      <div className="col-12 form-group">
                        <label>Code</label>

                        <input
                          className={`form-control code ${
                            this.state.codeError && 'red-border'
                          }`}
                          id="code"
                          type="text"
                          name="code"
                          value={this.state.code}
                          onChange={this.handleInputChange}
                          readOnly={!this.state.showCode}
                        />
                      </div>
                      {this.state.showPassword ? (
                        <Fragment>
                          <div className="col-12  form-group">
                            <label>{decode(this.state.signupData[18])}</label>

                            <input
                              id="password"
                              type="password"
                              className={`form-control ${
                                this.state.passwordError && 'red-border'
                              }`}
                              name="password"
                              minLength="6"
                              required
                              value={this.state.password}
                              onChange={this.handleInputChange}
                              onBlur={this.handlePasswordValidation}
                            />
                          </div>

                          <div className="col-12  form-group ">
                            <label>{decode(this.state.signupData[19])}</label>

                            <input
                              id="password_confirmation"
                              type="password"
                              className={`form-control ${
                                this.state.passwordError && 'red-border'
                              }`}
                              name="password_confirmation"
                              minLength="6"
                              required
                              value={this.state.password_confirmation}
                              onChange={this.handleInputChange}
                              onBlur={this.handlePasswordValidation}
                            />
                          </div>
                          {this.state.errorText !== '' && (
                            <ErrorLabel errorMessage={this.state.errorText} />
                          )}

                          {this.state.error !== '' && (
                            <Error error={this.state.error} />
                          )}
                          <div className="submit-btn">
                            <Button
                              type="submit"
                              color="primary"
                              loading={this.state.loading}
                            >
                              {'Activate'}
                            </Button>
                          </div>
                        </Fragment>
                      ) : (
                        <Fragment>
                          {this.state.errorText !== '' && (
                            <ErrorLabel errorMessage={this.state.errorText} />
                          )}

                          {this.state.error !== '' && (
                            <Error error={this.state.error} />
                          )}
                          <div className="submit-btn">
                            <Button
                              type="submit"
                              color="primary"
                              loading={this.state.loading}
                            >
                              {'Next'}
                            </Button>
                          </div>
                        </Fragment>
                      )}
                    </form>
                    <div className="row col-md-12 pt-3">
                      <p className="font-size-16">
                        {decode(this.state.signupData[21])}
                        &nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Terms of Supply"
                        >
                          {decode(this.state.signupData[22])}
                        </Link>
                        &nbsp;&nbsp;--&nbsp;&nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Terms of Use"
                        >
                          {decode(this.state.signupData[37])}
                        </Link>
                        &nbsp;&nbsp;--&nbsp;&nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Privacy Policy"
                        >
                          {decode(this.state.signupData[42])}
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          style={{
            zIndex: 9999999,
            position: 'absolute',
            height: '40px',
            width: '200px',
          }}
        >
          <Modal
            showModal={this.state.showModal}
            handleClose={this.hideModal}
            data={this.state.signupData}
            modalContent={this.state.modalContent}
          >
            <div
              className="modal-body"
              dangerouslySetInnerHTML={{
                __html:
                  this.state.modalContent == 'Terms of Supply'
                    ? decode(this.state.signupData[35])
                    : this.state.modalContent == 'Terms of Use'
                      ? decode(this.state.signupData[39])
                      : decode(this.state.signupData[41]),
              }}
            ></div>
          </Modal>
        </div>
      </div>
    )
  }
}

export default withRouter(withSearch(withAuth(SignupGiftActivate)))
